
const Footer = () => {
    return (
        <footer className="text-center user-select-none mt-4">
            <hr/>
            <p>&copy; Workshop PBB {new Date().getFullYear()}</p>
        </footer>
    );
};

export default Footer;